import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { ITyped } from '../../shared/interfaces/typed.interface';
import { DashboardComponentTypesEnum } from '../reports.enum';

export const LINK_SCHEMA = Object.freeze({
  TYPE: '',
  LABEL: '',
  URL: '',
  GROUP: 0,
});
const RECORD = generateSchema(LINK_SCHEMA);
const KEYS: any = generateKeys(LINK_SCHEMA);

export class Link extends Record(RECORD) implements ITyped {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): string {
    return DashboardComponentTypesEnum.link;
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get url(): string {
    return this.get(KEYS.URL);
  }

  get group(): number {
    return this.get(KEYS.GROUP);
  }
}
